import React from 'react';
import { css } from '@emotion/react';
import Image from 'next/image';
import Link from 'next/link';
import theme from '@/styles/theme';

const ContentPosterContainer = () => {
  return (
    <div css={container}>
      <Image
        src="/assets/img_contest_detail.jpg"
        layout="fill"
        objectFit="cover"
        alt="contest detail"
        placeholder="blur"
        blurDataURL="/assets/img_contest_detail.jpg"
      />
      <Link href="https://studio.storyplay.com">
        <button className="button" />
      </Link>
    </div>
  );
};
const container = css`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100vw;
  max-width: ${theme.maxWidth};
  padding-bottom: 562.5%;

  .button {
    position: absolute;
    top: calc(800px * 5.43125);
    width: 600px;
    height: 90px;
    cursor: pointer;

    @media screen and (max-width: ${theme.devices.mobile}) {
      top: calc(100vw * 5.43125);
      width: 300px;
      height: 45px;
    }
  }
`;
export default ContentPosterContainer;
